<template lang="pug">
  //- アカウント追加画面
  #add-account
    b-card
      .mb-2
        b-button.mr-2(variant="outline-secondary", :to="{ name: 'AccountList' }", :disabled="isLoading") 戻る
        b-button(v-b-modal.add-modal, variant="outline-success", :disabled="isLoading") 申込メール送信
      b-form-text.my-2.align-left.text-left.error-message-color(v-for="(message, key) of error_msg_list", :key="key") {{message}}
      //- アカウント追加フォーム
      b-container.border-top.border-bottom.mb-2(fluid)
        b-row.border-bottom.mx-1
          b-col.p-2.border-right.font-weight-bold.table-title-col-width ユーザー名
          b-col.p-2
            b-form-input(size="sm", type="text", :placeholder="user_name.placeholder", v-model="user_name.value" :class="user_mail.form_class")
            b-form-text.align-left.text-left.error-message-color(v-for="(message, key) of user_name.error_msg_list", :key="key") {{message}}
        b-row.border-bottom.mx-1
          b-col.p-2.border-right.font-weight-bold.table-title-col-width メールアドレス
          b-col.p-2
            b-form-input(size="sm", type="text", :placeholder="user_mail.placeholder", v-model="user_mail.value" :class="user_mail.form_class")
            b-form-text.align-left.text-left.error-message-color(v-for="(message, key) of user_mail.error_msg_list", :key="key") {{message}}
        b-row.mx-1
          b-col.p-2.border-right.font-weight-bold.table-title-col-width メールアドレス(確認用)
          b-col.p-2
            b-form-input(size="sm", type="text", :placeholder="re_user_mail.placeholder", v-model="re_user_mail.value" :class="user_mail.form_class")
            b-form-text.align-left.text-left.error-message-color(v-for="(message, key) of re_user_mail.error_msg_list", :key="key") {{message}}
      b-form-text.mx-1 {{description_1}}
      b-form-text.font-red.mx-1 {{description_2}}
      b-form-text.mx-1.mb-2.white-space {{description_3}}

      div
        b-button.mr-2(variant="outline-secondary", :to="{ name: 'AccountList' }", :disabled="isLoading") 戻る
        b-button(v-b-modal.add-modal, variant="outline-success", :disabled="isLoading") 申込メール送信

      //- 追加確認ダイアログ
      b-modal#add-modal(title="ご確認", ok-title="はい", cancel-title="いいえ", ok-variant="success", @ok="addAccount")
        template(#modal-header-close)
          span(title="閉じる") ×
        span アカウント追加申込メールを送信します。
          br
          | よろしいですか？
</template>

<script>
import Api from '@/repositories/api'

const AddAccountRepository = Api.get('s212AccountManagement')

export default {
  name: "AddAccount",
  data() {
    return {
      // ユーザー名
      user_name: { placeholder: "山田　太郎", value: "", error_msg_list: [], form_class: "middle-form-size" },
      // メールアドレス
      user_mail: { placeholder: "someone@example.com", value: "", error_msg_list: [], form_class: "middle-form-size" },
      // メールアドレス(確認用)
      re_user_mail: { placeholder: "確認のためにもう一度入力してください", value: "", error_msg_list: [], form_class: "middle-form-size" },

      description_1: "※アカウント追加URLが記載されたメールを送信します。",
      description_2: "※アカウント追加URLにアクセスしていただき、パスワードを設定するとアカウントが追加されます。",
      description_3: "※アカウント追加申込メール送信後、24時間を超過しますとセキュリティ保持のため有効期限切れとなります。\n" +
        "　その場合は再度、アカウント追加のお手続きをお願いいたします。",

      // 画面上部のエラーメッセージ
      error_msg_list: [],

      // ローディングフラグ
      isLoading: false,
    }
  },
  methods: {
    // アカウント追加登録
    addAccount() {
      // ボタンをロックする
      this.isLoading = true;

      // エラーメッセージ初期化
      this.user_name.error_msg_list    = []; // ユーザー名
      this.user_mail.error_msg_list    = []; // メールアドレス
      this.re_user_mail.error_msg_list = []; // メールアドレス(確認用)
      this.error_msg_list              = []; // 画面上部のエラーメッセージ

      // リクエストデータ作成
      let params = {
        user_name:    this.user_name.value,    // ユーザー名
        user_mail:    this.user_mail.value,    // メールアドレス
        re_user_mail: this.re_user_mail.value, // メールアドレス(確認用)
      }

      // アカウント追加処理
      AddAccountRepository.add(params)
      // 成功した場合
      .then(() => {
        // アカウント一覧画面へ遷移する
        this.$router.push({
          name: 'AccountList'
        })
      })
      .catch((error) => {
        // 共通のエラー処理
        this.apiError(error, '登録処理')

        // httpステータスコードが403の場合（権限エラー）
        if (error.response.status === 403) {
          // 画面上部にエラーメッセージを表示する
          this.error_msg_list.push(this.forbidden_message);

          // 画面一番上へスクロールする
          this.pageTopScroll();
        }

        // バリデーションエラー
        if (error.response.data && error.response.data.error_list) {
          for (let errorData of error.response.data.error_list) {
            // エラーメッセージセット
            this[errorData.target].error_msg_list.push(errorData.error_msg)
          }
        }
      })
      .finally(() => {
        // ボタンのロックを解除する
        this.isLoading = false;
      })
    }
  }
}
</script>

<style scoped>
.table-title-col-width {
  min-width: 250px;
  max-width: 250px;
}
.middle-form-size {
  max-width: 500px;
}
.font-red {
  color: red !important;
}
.white-space {
  white-space: pre-wrap;
}
</style>